<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="data?.newsletter_title" class="relative flex aspect-[1920/750] w-full items-center">
    <nuxt-img
      provider="cloudinary"
      :src="data?.newsletter_image[0]"
      alt="newsletter"
      class="absolute z-0 hidden h-full w-full object-cover object-center md:block"
      loading="lazy"
      sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw"
      fit="fill"
      width="1920"
      height="750"
    />
    <nuxt-img
      provider="cloudinary"
      :src="data?.newsletter_image[0]"
      alt="newsletter"
      class="absolute z-0 h-full w-full object-cover object-right-top md:hidden"
      loading="lazy"
      sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw"
      fit="fill"
      width="600"
      height="1000"
    />
    <Container>
      <div class="relative z-40 mb-52 mt-12 max-w-screen-md lg:my-56">
        <div class="max-w-[75%] lg:max-w-screen-sm">
          <div class="mb-1.5 font-serif text-lg font-normal uppercase leading-snug text-blue">
            {{ $t('newsletter') }}
          </div>
          <div
            v-if="data?.newsletter_title"
            class="mb-6 max-w-[90%] font-serif text-4xl font-bold text-white lg:mb-5 lg:max-w-full lg:text-5xl lg:leading-snug"
          >
            {{ data.newsletter_title }}
          </div>
          <div
            v-if="data?.newsletter_copy?.value"
            class="font-sans text-base font-normal text-white lg:text-lg lg:leading-snug"
            v-html="data.newsletter_copy.value"
          ></div>
        </div>
        <div class="mt-36 lg:mt-16">
          <!-- Begin Mailchimp Signup Form -->

          <div id="mc_embed_signup_custom">
            <form
              id="mc-embedded-subscribe-form"
              :action="decodeHTML(action)"
              method="post"
              name="mc-embedded-subscribe-form"
              class="validate"
              target="_blank"
              novalidate
              @submit.prevent="validateAndSubmit"
            >
              <div id="mc_embed_signup_scroll">
                <div class="flex flex-col space-y-6 lg:flex-row lg:space-x-8 lg:space-y-0">
                  <div class="mc-field-group">
                    <Input
                      id="mce-FNAME"
                      v-model="user.name"
                      :v$="v$?.name"
                      :label="$t('firstName')"
                      type="text"
                      name="FNAME"
                      style-error="bg-transparent"
                      style-label="!text-white"
                      style-input="lg:w-full border border-transparent required "
                    />
                  </div>
                  <div class="relative flex flex-1 items-end">
                    <div class="mc-field-group relative flex-1">
                      <Input
                        id="mce-EMAIL"
                        v-model="user.email"
                        :v$="v$?.email"
                        :label="$t('email')"
                        type="email"
                        name="EMAIL"
                        style-error="bg-transparent"
                        style-label="!text-white"
                        style-input="rounded-r-none border-r-0 w-full border border-transparent required !h-[48px] lg:!h-[60px]"
                      >
                        <template #right>
                          <div
                            class="absolute -right-1 top-0 text-sm font-bold text-blue lg:left-[483px] lg:top-0"
                          >
                            <Button
                              :title="$t('send')"
                              class="!h-[48px] rounded-md rounded-l-none !border-0 border-none px-8 lg:!h-[60px] lg:px-12"
                              type-button="submit"
                              click-id="newsletter_submit"
                            />
                          </div>
                        </template>
                      </Input>
                    </div>

                    <div id="mce-responses" class="clear absolute top-[90px] lg:top-28">
                      <div
                        id="mce-error-response"
                        class="response font-sans text-xs font-bold text-white lg:text-sm"
                        style="display: none"
                      ></div>
                      <div
                        id="mce-success-response"
                        class="response font-sans text-white"
                        style="display: none"
                      ></div>
                    </div>
                  </div>
                </div>

                <!-- Visually hide these -->
                <!-- SWEDISH FORM -->
                <div v-if="siteLang === 'sv'" class="mc-field-group input-group sr-only">
                  <strong>Nyhetsbrev </strong>
                  <ul>
                    <li>
                      <input
                        id="mce-group[3903]-3903-0"
                        type="checkbox"
                        value="2"
                        name="group[3903][2]"
                        checked
                      />
                      <label for="mce-group[3903]-3903-0">Nyhetsbrevet</label>
                    </li>
                    <li>
                      <input
                        id="mce-group[3903]-3903-1"
                        type="checkbox"
                        value="4"
                        name="group[3903][4]"
                      />
                      <label for="mce-group[3903]-3903-1">Vegobrevet</label>
                    </li>
                    <li>
                      <input
                        id="mce-group[3903]-3903-2"
                        type="checkbox"
                        value="16"
                        name="group[3903][16]"
                      />
                      <label for="mce-group[3903]-3903-2">Aktuellt i politiken</label>
                    </li>
                    <li>
                      <input
                        id="mce-group[3903]-3903-3"
                        type="checkbox"
                        value="65536"
                        name="group[3903][65536]"
                      />
                      <label for="mce-group[3903]-3903-3">Övriga nyhetsbrev</label>
                    </li>
                    <li>
                      <input
                        id="mce-group[3903]-3903-4"
                        type="checkbox"
                        value="4194304"
                        name="group[3903][4194304]"
                      />
                      <label for="mce-group[3903]-3903-4">Testamentesveckan</label>
                    </li>
                  </ul>
                  <span id="mce-group[3903]-HELPERTEXT" class="helper_text"></span>
                </div>
                <!-- ENGLISH FORM -->
                <div v-if="siteLang === 'en'" class="mc-field-group input-group sr-only">
                  <strong>Newsletters </strong>
                  <ul>
                    <li>
                      <input
                        id="mce-group[3946]-3946-0"
                        type="checkbox"
                        name="group[3946][1]"
                        value="1"
                        checked
                      />
                      <label for="mce-group[3946]-3946-0">Newsletter</label>
                    </li>
                  </ul>
                </div>
                <!-- UKRAINE FORM -->
                <div v-if="siteLang === 'uk'" class="mc-field-group input-group sr-only"></div>

                <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                <div style="position: absolute; left: -5000px" aria-hidden="true">
                  <input type="text" :name="nameInput" tabindex="-1" value="" />
                </div>
              </div>
            </form>
          </div>

          <!--End mc_embed_signup-->
        </div>
      </div>
    </Container>
  </div>
</template>

<script setup lang="ts">
import { Input, Button, Container } from 'refresh-ui'
import { useVuelidate } from '@vuelidate/core'
import { required, email, helpers } from '@vuelidate/validators'
import type { SiteLang } from 'refresh-ui'

import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  data: Object,
})

const config = useRuntimeConfig()

const { siteLang } = config.public as {
  siteLang: SiteLang
}

const action = computed(() => {
  if (siteLang === 'en') {
    return `https://djurensratt.us20.list-manage.com/subscribe/post?u=075aef938fc7213aacd1f4476&amp;id=b92e31be96&amp;f_id=00f5c2e1f0`
  }
  // default sv
  return `https://djurensratt.us20.list-manage.com/subscribe/post?u=075aef938fc7213aacd1f4476&amp;id=2576ca066f&amp;f_id=00cac2e1f0`
})

const nameInput = computed(() => {
  if (siteLang === 'en') {
    return 'b_075aef938fc7213aacd1f4476_b92e31be96'
  }
  // default sv
  return 'b_075aef938fc7213aacd1f4476_2576ca066f'
})

// === Form state and validation ===
const user = ref({
  email: '',
  name: '',
})

const rules = {
  name: { required: helpers.withMessage(t('firstName.requiredMessage'), required) },
  email: {
    required: helpers.withMessage(t('email.requiredMessage'), required),
    email: helpers.withMessage(t('email.errorMessage'), email),
  },
}

const v$ = useVuelidate(rules, user.value)

const validateAndSubmit = async () => {
  v$.value.$touch()
  await v$.value.$validate()

  if (v$.value.$invalid) {
    return
  }
  if (!v$.value.$error) {
    const formEl = document.getElementById('mc-embedded-subscribe-form') as HTMLFormElement | null
    formEl?.submit()
  }
}

// Mailchimp script config (no longer needed for redirect to work)
// const scriptString = computed(() => {
//   if (siteLang === 'en') {
//     return `(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[1]='FNAME';ftypes[1]='text';fnames[0]='EMAIL';ftypes[0]='email';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';}(jQuery));var $mcj = jQuery.noConflict(true);`
//   }

//   // default sv
//   return `(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';fnames[5]='BIRTHDAY';ftypes[5]='birthday';fnames[6]='MMERGE6';ftypes[6]='text';fnames[7]='HASHKOD';ftypes[7]='text';fnames[8]='MMERGE8';ftypes[8]='date';fnames[9]='FORETAG';ftypes[9]='text'; }(jQuery));var $mcj = jQuery.noConflict(true);`
// })

onMounted(() => {
  if (!props?.data?.newsletter_title) return

  // Load jQuery (optional — only needed if other scripts depend on it)
  const jQueryScript = document.createElement('script')
  jQueryScript.src = 'https://code.jquery.com/jquery-3.3.1.slim.min.js'
  jQueryScript.type = 'text/javascript'
  jQueryScript.async = true
  jQueryScript.defer = true
  document.body.appendChild(jQueryScript)

  // Disable Mailchimp plugin script to allow redirect to work
  // jQueryScript.onload = () => {
  //   const plugin = document.createElement('script')
  //   plugin.innerHTML = scriptString.value
  //   plugin.async = true
  //   document.getElementsByTagName('body')[0].appendChild(plugin)
  // }

  // Disable mc-validate.js (Mailchimp’s script that blocks redirect)
  // const script = document.createElement('script')
  // script.src = '/js/mc-validate.js'
  // script.async = true
  // script.defer = true
  // document.getElementsByTagName('body')[0].appendChild(script)
})
</script>

<!-- <style>
#mc_embed_signup_custom div.mce_inline_error {
  position: absolute;
  background: transparent !important;
  padding: 0 !important;
  margin-top: 9px !important;
  font-size: 12px !important;
  @media (min-width: 1024px) {
    font-size: 14px !important;
  }
}
#mc_embed_signup_custom input.mce_inline_error {
  border: 1px solid red !important;
}
</style> -->
